 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import BACKEDBIRDSFRONT_1 from '@/components/backed/birdsfront_1'
 import LOVE_1 from '@/components/love_1'
 import TITLE from '@/components/title'
 import CONTENT from '@/components/Content'
 import AUTHOR from '@/components/author'
 import KEY from '@/components/key'
 import INTERODUCTION from '@/components/interoduction'
 import A from '@/components/A'
 import B from '@/components/B'
 import C from '@/components/C'
 import D from '@/components/D'
 import E from '@/components/E'
 import F from '@/components/F'
 import G from '@/components/G'
 import H from '@/components/H'
 import I from '@/components/I'
 import J from '@/components/J'
 import K from '@/components/K'
 import L from '@/components/L'
 import M from '@/components/M'
 import N from '@/components/N'
 import O from '@/components/O'
 import P from '@/components/P'
 import R from '@/components/R'
 import S from '@/components/S'
 import T from '@/components/T'
 import U from '@/components/U'
 import V from '@/components/V'
 import W from '@/components/W'
 import Y from '@/components/Y'
 import LOVE_2 from '@/components/love_2'
 import COPYRIGHT from '@/components/Copyright'
 import BACKEDBACKAD_1 from '@/components/backed/backad_1'
 import BACKEDPHILOSO_1 from '@/components/backed/philoso_1'
 import BACKEDORIMAD_1 from '@/components/backed/ORIM-ad_1'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Content",
 			"name" : "Content",
 			"component" : CONTENT
 		},
 		{
 			"path" : "/author",
 			"name" : "author",
 			"component" : AUTHOR
 		},
 		{
 			"path" : "/key",
 			"name" : "key",
 			"component" : KEY
 		},
 		{
 			"path" : "/interoduction",
 			"name" : "interoduction",
 			"component" : INTERODUCTION
 		},
 		{
 			"path" : "/A",
 			"name" : "A",
 			"component" : A
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js